<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Terminals"
              bc1="App"
              bc2="Terminals"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb ">
                      <li class="breadcrumb-item"><a href="javascript:void(0)">Store</a></li>
                      <li class="breadcrumb-item" v-for="(crumb,index) in currentBreadCrumb">{{crumb}}</li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div class="col-6">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="routeToAddRecord"
                  >
                    <AddButtonText name="Terminal" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <CommonTable
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :filteredData="filteredData"
              :externalTotalRecord="externalTotalRecord"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {AddButtonText},

  created() {},
  mounted() {
    localStorage.setItem("url",this.url);
    this.checkDataInStore(this.url)
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    var merchantTerminal = this.$store.getters.getByKey(
        "merchantTerminal"
    );
    this.storeId = merchantTerminal.row.id
    this.filteredData = {
      storeId: this.storeId
    }

    this.currentBreadCrumb.push(merchantTerminal.row.name+'/'+merchantTerminal.row.code)
  },
  data() {
    return {
      currentBreadCrumb:[],
      url: "v1/get-terminal",
      storageKey: "merchantTerminalList",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == true) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }


            return html;
          }
        }
      ],
      actions: [
        {
          title: "Update",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantTerminalUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "update-terminal",params: {storeId : this.storeId} });
          }
        },
        {
          title: 'Channel',
          class: 'btn-warning',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantChannel"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "channel" });
          },

        },
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantTerminalDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: "",
      filteredData:{},
      storeId:''
    };
  },
  methods: {
    routeToAddRecord(){
      this.$router.push({ name: "add-terminal",params: {storeId : this.storeId}})

    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-terminal", {
        status: data.row.status == true ? 1 : 0,
        terminalId: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey(this.storageKey);
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                    typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                    typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = this.storageKey;
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>
